import { mergeTranslations } from '../merge';
import account from './account';
import activities from './activities';
import billing from './billing';
import common from './common';
import connectors from './connectors';
import entities from './entities';
import features from './features';
import objectives from './objectives';
import organizations from './organizations';
import projects from './projects';
import settings from './settings';
import tasks from './tasks';
import templates from './templates';
import users from './users';

export default mergeTranslations(
  account,
  activities,
  billing,
  common,
  connectors,
  entities,
  features,
  objectives,
  organizations,
  projects,
  settings,
  tasks,
  templates,
  users,
);
